import type { VehicleCategory, VehicleStatus } from "@/types";

export const categoryLabels: Record<VehicleCategory, string> = {
  camiones: "Camiones",
  vans: "Furgonetas y Vans",
  autobuses: "Autobuses",
  eventos: "Eventos",
  especiales: "Especiales",
};

export const categoryOptions: { value: VehicleCategory; label: string }[] = [
  { value: "camiones", label: "Camiones" },
  { value: "vans", label: "Furgonetas y Vans" },
  { value: "autobuses", label: "Autobuses" },
  { value: "eventos", label: "Eventos" },
  { value: "especiales", label: "Especiales" },
];

export const capacidadOptions = [
  { value: "baja", label: "Carga ligera" },
  { value: "media", label: "Carga media" },
  { value: "alta", label: "Carga alta" },
];

export const estadoOptions: { value: VehicleStatus; label: string }[] = [
  { value: "disponible", label: "Disponible" },
  { value: "reservado", label: "Reservado" },
  { value: "mantenimiento", label: "En mantenimiento" },
  { value: "no_disponible", label: "No disponible" },
];

export const servicioOptions = [
  "Mudanzas",
  "Acarreo",
  "Transporte para eventos",
  "Distribución",
  "Reparto",
  "Transporte empresarial",
  "Transporte para grupos",
  "Servicios especiales",
];